import '../DeckNav.css';
import DeckNav from "../DeckNav";
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import Footer from '../../Components/Footer/Footer';
//one folder up so use ../
//if two folders away use ../../
import { ConsonantDeckFace } from "../../DeckCardOverviews/Phonetics/PhoneticsOv";

export default function ConsonantsNav() {
  return (
<div>
  <SPLoader time={0.2}/>
  <HeaderNav GoBack_to={"/"}/>
  <DeckNav faceCard={ConsonantDeckFace} title_input="Consonants"/> 
    <Footer/>
</div>
  )
}



